module.exports = __webpack_public_path__ + "img/bottom1.9292d16a.png";